import { type ChangeEvent, type FC } from "react";

import { cx } from "@emotion/css";
import { Group, Stack, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";

import { useFeatureGates } from "../../../../cof-feature-gates/hooks";
import { CofConfigId } from "../../../../gql-generated/types";
import { PageHeader, PageHeaderContainer } from "../../../../layout/components";
import { useSelectedLensCentralOrganizationNotIncludesCamkitOrgs } from "../../../../shared/hooks";
import { useSelectedOrganization } from "../../../../shared/hooks/useSelectedOrganization";
import { truncate } from "../../../../shared/styles";
import lensFolderStyles from "../LensFoldersList.module.css";

import { AddFolderModal } from "./AddLensFolder";
import { input } from "./LensFoldersPageHeader.module.css";

interface LensFoldersPageHeader {
    searchText: string;
    setSearchText: (value: string | ChangeEvent) => void;
}

export const LensFoldersPageHeader: FC<LensFoldersPageHeader> = ({ searchText, setSearchText }) => {
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    const selectedOrganization = useSelectedLensCentralOrganizationNotIncludesCamkitOrgs();
    const selectedOrganizationV2 = useSelectedOrganization();

    const organizationName = isMyLensesOrgsV2Enabled ? selectedOrganizationV2?.name : selectedOrganization?.name;

    return (
        <Group data-testid="lens-folders-grid-header" justify="space-between">
            <Stack>
                <PageHeaderContainer>
                    <PageHeader
                        data-testid="lens-folders-grid-title"
                        className={cx(lensFolderStyles.organizationName, truncate)}
                    >
                        {organizationName}
                    </PageHeader>
                </PageHeaderContainer>
                <TextInput
                    variant="filled"
                    miw="50vw"
                    value={searchText}
                    leftSection={<IconSearch />}
                    onChange={setSearchText}
                    placeholder={"Search folders"}
                    className={input}
                />
            </Stack>
            <AddFolderModal />
        </Group>
    );
};
